import { render, staticRenderFns } from "./StoreMarketingAdd.vue?vue&type=template&id=2ea27410&scoped=true"
import script from "./StoreMarketingAdd.vue?vue&type=script&lang=js"
export * from "./StoreMarketingAdd.vue?vue&type=script&lang=js"
import style0 from "./StoreMarketingAdd.vue?vue&type=style&index=0&id=2ea27410&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea27410",
  null
  
)

export default component.exports